import useProjectsApi from '../../../projects/projectsApi';

export type BlockStyle = {
  backgroundColor: string;
  fontColor: string;
  shadingColor: string;
  highlightColor: string;
};

export type Theme = {
  coloredBackgroundBlock: BlockStyle;
  whiteBackgroundBlock: BlockStyle;
  grayBackgroundBlock: BlockStyle;
};

export type DomainDto = {
  subdomain: string;
};

export type BrandingDto = {
  logoFileId?: number;
  _logoUrl?: {
    resized: string;
    full: string;
  };
  theme: Theme;
};

export type UpdateBrandingRequest = {
  logoFileId?: number;
  theme?: Theme;
};

export default function useClientPortalService() {
  const nekstApi = useProjectsApi();

  const getDomain = async () => {
    return await nekstApi.get('/settings/clientportal/domain') as DomainDto;
  };

  const updateDomain = async (subdomain: string) => {
    return await nekstApi.post('/settings/clientportal/domain', { subdomain }) as DomainDto;
  };

  const getBranding = async () => {
    return await nekstApi.get('/settings/clientportal/branding') as BrandingDto;
  };

  const updateBranding = async (request: UpdateBrandingRequest) => {
    return await nekstApi.post('/settings/clientportal/branding', request) as BrandingDto;
  };

  return {
    getDomain,
    updateDomain,
    getBranding,
    updateBranding,
  };
}
